import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';
import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';
import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';

import Section from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import './HiwComparison.scss';

const Check = () => {
  const { isBiggerThanTablet } = useMediaQuery();
  return (
    <div className="hiw-comparison__icon-container">
      <span className="hiw-comparison__icon hiw-comparison__icon--check">
        <DSIcon name="done_check" size={isBiggerThanTablet() ? 'l' : 'm'} />
      </span>
    </div>
  );
};

const Nay = () => {
  const { isBiggerThanTablet } = useMediaQuery();
  return (
    <div className="hiw-comparison__icon-container">
      <span className="hiw-comparison__icon hiw-comparison__icon--nay">
        <DSIcon name="close" size={isBiggerThanTablet() ? 'l' : 'm'} />
      </span>
    </div>
  );
};

const HiwComparison = () => {
  const depositProtectionOnlyPlus = useSoyuzExperiment(
    'DepositProtectionOnlyPlus'
  );
  const isDepositProtectionVariant =
    depositProtectionOnlyPlus.get('behaviour') === 'variant';

  return (
    <Section className="hiw-comparison">
      <h2 className="hiw-comparison__title hiw-comparison__title--mobile">
        {trans('how_it_works.comparison.title')}
      </h2>
      <div className="hiw-comparison__table">
        <h2 className="hiw-comparison__title">
          {trans('how_it_works.comparison.title')}
        </h2>
        <div className="hiw-comparison__table-header">
          <LazyLoad
            as="span"
            offset={100}
            once
            className="hiw-comparison__table-header-logo"
          >
            <img
              src="https://static.spotahome.com/logo/sah-logo-symbol.svg"
              alt="Spotahome"
            />
          </LazyLoad>
        </div>
        <div className="hiw-comparison__table-header">
          {trans('how_it_works.comparison.header.others')}
        </div>
        <div className="hiw-comparison__item">
          <p>{trans('how_it_works.comparison.item1')}</p>
          <p>{trans('how_it_works.comparison.item1.subtitle')}</p>
        </div>
        <Check />
        <Nay />
        <div className="hiw-comparison__item">
          <p>{trans('how_it_works.comparison.item2')}</p>
          <p>
            {trans(
              isDepositProtectionVariant
                ? 'how_it_works.comparison.item2.deposit-protection.subtitle'
                : 'how_it_works.comparison.item2.subtitle'
            )}
          </p>
        </div>
        <Check />
        <Nay />
        <div className="hiw-comparison__item">
          <p>{trans('how_it_works.comparison.item3')}</p>
          <p>{trans('how_it_works.comparison.item3.subtitle')}</p>
        </div>
        <Check />
        <Nay />
        <div className="hiw-comparison__item">
          <p>{trans('how_it_works.comparison.item4')}</p>
          <p>{trans('how_it_works.comparison.item4.subtitle')}</p>
        </div>
        <Check />
        <Nay />
      </div>
      <p className="hiw-comparison__disclaimer">
        {trans('how_it_works.comparison.disclaimer')}
      </p>
    </Section>
  );
};

export default HiwComparison;
